export enum ReCaptchaEnterpriseAction {
    LOGIN = 'login',
    SIGN_UP = 'sign_up',
}

export enum RecaptchaEnterpriseAssessmentStatus {
    APPROVED = 'approved',
    NOT_APPROVED = 'not-approved',
}

export enum RecaptchaEnterpriseAssessmentError {
    INVALID_TOKEN = 'invalid-token',
    INVALID_ACTION = 'invalid-action',
    RISK_REASONS = 'risk-reasons',
}

export interface RecaptchaEnterpriseAssessment {
    status: RecaptchaEnterpriseAssessmentStatus;
    score: number;
}